import { Store } from "~/bff/types/Store";

export const isCurrentStoreInCurrentLocation = (
  countryCode: string,
  store?: Store | null,
): boolean => {
  const storeCountryCode = store?.countryCode ?? store?.address.countryCode;
  return countryCode?.toLowerCase() === storeCountryCode?.toLowerCase();
};
